import * as actionType from "../../context/actions";

const GetSoldItemsData = async (state, dispatch, data, manualItems = null) => {
    if (!Array.isArray(data)) return null;

    try {
        const soldItemsMap = new Map();
        const itemsList = manualItems || state?.ITEMS || [];

        data.forEach(info => {
            info?.items?.forEach(item => {
                const price = (parseFloat(item.price) || 0)?.toFixed(2);
                const quantity = parseInt(item.quantity) || 0;
                const total_amount = (parseFloat(item.price) * parseInt(item.quantity))?.toFixed(2);
                const itemId = item.itemId || item.name || 'unknown';
                const currency = info.currency || "";
                const key = `${itemId}_${currency}`;

                if (!soldItemsMap.has(key)) {
                    soldItemsMap.set(key, {
                        companyId: info.companyId,
                        name: item.name || itemsList?.find(i => i?.itemId === item?.itemId)?.name || "",
                        price,
                        quantity,
                        total_amount: total_amount,
                        invoiceIds: info.invoiceId ? [info.invoiceId] : [],
                        date: info.creationDate || "",
                        subtitle: item.subtitle || "",
                        createdBy: info.createdBy || null,
                        createdById: state?.USERID || null,
                        currency,
                    });
                } else {
                    const existingItem = soldItemsMap.get(key);
                    const existingTotal = parseFloat(existingItem.total_amount) || 0;
                    const newTotal = parseFloat(total_amount) || 0;

                    soldItemsMap.set(key, {
                        ...existingItem,
                        quantity: existingItem.quantity + quantity,
                        total_amount: (existingTotal + newTotal).toFixed(2),
                        invoiceIds: info.invoiceId
                            ? Array.from(new Set([...existingItem.invoiceIds, info.invoiceId]))
                            : existingItem.invoiceIds,
                        date:
                            info.creationDate &&
                                (!existingItem.date || new Date(info.creationDate) > new Date(existingItem.date))
                                ? info.creationDate
                                : existingItem.date,
                    });
                }
            });
        });

        const soldItems = Array.from(soldItemsMap.values()).map((item, index) => ({
            srNo: index + 1,
            ...item,
        }));

        // Optional dispatch
        dispatch({ type: actionType.SOLDITEMS, payload: soldItems });

    } catch (error) {
        console.error("Error fetching sold items data:", error);
        return null;
    }
};

export default GetSoldItemsData;
